window.ListarNotasFiscaisEntradaController = ControllerBase.extend({
    name: 'ListarNotasFiscaisEntradaController',
    framework: 'knockout',

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Filial', prop: 'Filial' },
            { title: 'Nº Orçamento', prop: 'NumeroPedido' },
            { title: 'Cliente', prop: 'RazaoSocialCliente' },
            { title: 'Vendedor', prop: 'Vendedor' },
            { title: 'Data', prop: 'DataPedido', type: 'Date' },
            { title: 'Valor', prop: 'ValorPedido', type: 'Money' }
        ],
        getData: function () {
            return ko.mapping.toJS(this.orcamento);
        },
    }),

    ajax: function () {
        return {
            url: '/NotaFiscalEntrada/_NotasFiscais',
            type: 'post',
            data: {
                numeroOrcamento: this.orcamento.NumeroPedido()
            }
        };
    },

    renderizado: function() {
        this.modelPesquisa.NotasFiscais(true);
        this.modelPesquisa.NotaDevolucao(true);
    },

    antesBinding: function () {
        this.appendToModel({ name: 'notaSelecionada', value: null });
    },

    onhide: function() {
        this.modelPesquisa.NotasFiscais(false);
        this.modelPesquisa.NotaSelecionada(false);
        this.modelPesquisa.NotaDevolucao(false);
    },
    
    selecionar: function(model) {
        this.model.notaSelecionada(model);
        this.modelPesquisa.NotaSelecionada(true);
    },

    itens: function() {
        this.itensNotaFiscalEntradaController = this.showView({
            region: {
                name: 'ItensNotaFiscalEntradaControllerRegion',
                selector: '#itens-devolucao-region'
            },
            controller: {
                type: ItensNotaFiscalEntradaController,
                args: {
                    notaFiscal: this.model.notaSelecionada(),
                    modelPesquisa: this.modelPesquisa,
                    orcamento: ko.mapping.toJS(this.orcamento)
                }
            }
        });
    },
    financeiro: function() {
        this.creditoDevolucaoNotaFiscalEntradaController = this.showView({
            region: {
                name: 'financeiroNotaFiscalOrcamentoControllerRegion',
                selector: '#financeiro-devolucao-region'
            },
            controller: {
                type: CreditoDevolucaoNotaFiscalEntradaController,
                args: {
                    notaFiscal: this.model.notaSelecionada(),
                    modelPesquisa: this.modelPesquisa
                }
            }
        });
    }
});